import { useEffect } from 'react';

/* Client-side JSON-LD injector for the SPA (no SSR / Helmet).
   Deduplicates by `id` (removes any existing node before re-adding) and
   removes on unmount to avoid accumulation across client-side route changes. */
export default function useJsonLd(id, data) {
  const json = data ? JSON.stringify(data) : '';
  useEffect(() => {
    if (!json) return undefined;
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = json;
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [id, json]);
}
